import { ChangeEvent } from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Filter } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface FilterProps {
  searchTerm: string
  assignment: 'all' | 'active' | 'inactive'
  status: 'all' | 'Online' | 'Offline'
  totalRides:
    | 'all'
    | '0'
    | '1-5'
    | '6-10'
    | '11-25'
    | '26-50'
    | '51-100'
    | '100+'
  acceptsCash: 'all' | '0' | '1' | '2'
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void
  onAssignmentChange: (value: string) => void
  onStatusChange: (value: string) => void
  onTotalRidesChange: (value: string) => void
  onAcceptsCashChange: (value: string) => void
}

export default function DriversFilter({
  searchTerm,
  assignment,
  status,
  totalRides,
  acceptsCash,
  onSearchChange,
  onAssignmentChange,
  onStatusChange,
  onTotalRidesChange,
  onAcceptsCashChange,
}: FilterProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Filter className="h-5 w-5" />
          Filtros
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <div className="flex-1">
          <Label htmlFor="search">Buscar Motorista</Label>
          <Input
            id="search"
            placeholder="Nome do motorista..."
            value={searchTerm}
            onChange={onSearchChange}
          />
        </div>
        <div>
          <Label htmlFor="assignment">Assinatura</Label>
          <Select value={assignment} onValueChange={onAssignmentChange}>
            <SelectTrigger>
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              <SelectItem value="active">Com assinatura</SelectItem>
              <SelectItem value="inactive">Sem assinatura</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="status">Status</Label>
          <Select value={status} onValueChange={onStatusChange}>
            <SelectTrigger>
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              <SelectItem value="Online">Online</SelectItem>
              <SelectItem value="Offline">Offline</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="totalRides">Total de Corridas</Label>
          <Select value={totalRides} onValueChange={onTotalRidesChange}>
            <SelectTrigger>
              <SelectValue placeholder="Todas" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas</SelectItem>
              <SelectItem value="0">Nenhuma corrida</SelectItem>
              <SelectItem value="1-5">1 a 5 corridas</SelectItem>
              <SelectItem value="6-10">6 a 10 corridas</SelectItem>
              <SelectItem value="11-25">11 a 25 corridas</SelectItem>
              <SelectItem value="26-50">26 a 50 corridas</SelectItem>
              <SelectItem value="51-100">51 a 100 corridas</SelectItem>
              <SelectItem value="100+">Mais de 100 corridas</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="acceptsCash">Aceita Dinheiro</Label>
          <Select value={acceptsCash} onValueChange={onAcceptsCashChange}>
            <SelectTrigger>
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              <SelectItem value="0">Não Aceita Dinheiro</SelectItem>
              <SelectItem value="1">Aceita Dinheiro</SelectItem>
              <SelectItem value="2">Restrito</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  )
}
